import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root');

// createRoot - React preia controlul.
// HTML-ul pre-randat de react-snap ramane in sursa paginii pentru crawleri/SEO.
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
